module.exports = __webpack_public_path__ + "static/pe5-acc442203f4be98b505935f2c871d2e0.png";